import { StudioDetailPage } from './StudioDetailPage'

export const dummyStudioDetailPageData = {
  __typename: 'Studio',
  id: '/api/studios/018c67db-dffc-7160-8237-f385e7d89aa8',
  title: 'Wuppertal',
  name: 'SUNPOINT Sonnenstudio Wuppertal: Deine Schönheitsoase für perfekte Bräune & effektives Bodyforming',
  slug: 'wuppertal',
  studioType: 'Filialkette',
  info:
    '<p>Erlebe deinen persönlichen Wohlfühlmoment im SUNPOINT Sonnenstudio Wuppertal. Dich erwarten vielfältige Leistungen in den Bereichen Beauty, Wellness und Fitness. Bräune auf den komfortablen SUNSELECT Sonnenbänken, genieße UV-freies Spray Tanning in der TANTASTIC Bräunungsdusche oder verbinde Sonnenbaden mit einem verbesserten Hautbild durch die innovative Kombination von UV- und Collagenlicht bei WELLMAXX collatan. Darüber hinaus umfasst unser Angebot auch effektives Bodyforming sowie hochwertige Kosmetik. Das SUNPOINT Beauty- &amp; Tanning-Studio an der Clausewitzstraße 82 erreichst sowohl mit dem Auto (A1, Ausfahrt: Wuppertal-Langerfeld) als auch per Bus (Haltestelle: Jesinghausen) und Bahn (Haltestelle: Wuppertal-Langerfeld).</p>\r\n' +
    '<p><em>Optimiere dein Hautbild – mit der LIFTmee LED mask Farblichttherapie im Solarium Wuppertal</em></p>\r\n' +
    '<p>Als absolutes Highlight bieten wir dir im SUNPOINT Sonnenstudio Wuppertal eine neuartige Farblichttherapie. Mit der wirksamen LIFTmee LED mask kannst du Hautprobleme effizient bekämpfen. Ein optimales Zusammenspiel aus Collagenlicht, blauem Licht und Infrarotlicht sorgt für revitalisierte, gestraffte sowie beruhigte Haut. Drei unterschiedliche Programme stehen zur Auswahl: Collagenlicht/Infrarotlicht, Blaulicht/Infrarotlicht, Collagenlicht/Infrarotlicht/Blaulicht.</p>',
  clientStudioId: '9-T285',
  address: '<p>Clausewitzstraße 82<br /> 42389 Wuppertal</p>',
  phone: '0202-37190017',
  parkingAvailable: true,
  sisyCashbox: false,
  adyenMerchantAccount: 'SUNPOINT_AG_Fil',
  payPalMerchantId: '5UEZV5NT7NU7J',
  latitude: 51.2824665,
  longitude: 7.2548116,
  cidNumber: '7407202973969379132',
  specialOpeningHour:
    '<p><strong>Sonderöffnungszeiten</strong><br /> 24.12.23 10 - 14 Uhr<br /> 25.12.23 Geschlossen<br /> 26.12.23 10 - 18 Uhr<br /> 31.12.23 10 - 14 Uhr<br /> 01.01.24 Geschlossen</p>',
  specialOpeningHourInfo: '',
  seoTitle: 'Sunpoint Solarium Wuppertal: Ihr Studio für die ideale Bräune',
  seoDescription:
    'Genießen Sie die komplette Bandbreite unserer modernen Sunpoint Angebote im Solarium Wuppertal in offener und angenehmer Atmosphäre.',
  seoKeywords: 'Solarium Wuppertal',
  openingHoursWeekdays: '8 - 22 Uhr',
  openingHoursSaturday: '8 - 21 Uhr',
  openingHoursSunday: '8 - 21 Uhr',
  openingHoursPublicHoliday: '10 - 20 Uhr',
  openingHoursLastEntrance: 'Letzter Einlass 30 Minuten vor Ladenschluss',
  contracts: {
    __typename: 'ContractCursorConnection',
    edges: [
      [Object],
      [Object],
      [Object],
      [Object],
      [Object],
      [Object],
      [Object],
      [Object],
    ],
  },
  categories: {
    __typename: 'CategoryCursorConnection',
    edges: [
      [Object],
      [Object],
      [Object],
      [Object],
      [Object],
      [Object],
      [Object],
      [Object],
      [Object],
      [Object],
      [Object],
      [Object],
      [Object],
      [Object],
      [Object],
      [Object],
      [Object],
      [Object],
      [Object],
    ],
  },
}

export default StudioDetailPage
